module.exports = __webpack_public_path__ + "img/no-notification.4a20f328.png";